import { Route, Routes } from 'react-router-dom';
import {
  FormBuilderList,
  FormBuilderPage,
  LibraryAtomsPage,
  LibraryBlocksPage,
  LibraryBuildersPage,
  LibraryContainerDetailPage,
  LibraryContainersPage,
  LibraryScriptsPage,
  LibraryTemplateDetailPage,
  LibraryTemplatesPage,
  ReportBuilderList,
  ReportBuilderPage,
  RuleBuilderList,
  RuleBuilderPage,
} from '@/capabilities/automation-library/public/routes/lazyPages';
import { destinationCapabilityRouteElements } from '@/app/navigation/routes/capabilities/destinationCapabilityRegistry';

export function LibraryRoutes() {
  return (
    <Routes>
      <Route index element={<LibraryContainersPage />} />
      <Route path="containers/:slug" element={<LibraryContainerDetailPage />} />
      <Route path="templates" element={<LibraryTemplatesPage />} />
      <Route path="templates/:slug" element={<LibraryTemplateDetailPage />} />
      <Route path="blocks" element={<LibraryBlocksPage />} />
      <Route path="atoms" element={<LibraryAtomsPage />} />
      <Route path="authoring" element={<LibraryBuildersPage />} />
      <Route path="scripts" element={<LibraryScriptsPage />} />
      <Route path="builders/report" element={<ReportBuilderList />} />
      <Route path="builders/report/forms" element={<FormBuilderList />} />
      <Route path="builders/report/forms/:id" element={<FormBuilderPage />} />
      <Route path="builders/report/:id" element={<ReportBuilderPage />} />
      <Route path="builders/rule" element={<RuleBuilderList />} />
      <Route path="builders/rule/:kind/new" element={<RuleBuilderPage />} />
      <Route path="builders/rule/:kind/:id" element={<RuleBuilderPage />} />
      {destinationCapabilityRouteElements('library')}
    </Routes>
  );
}
